







import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Display a button element
 **/
@Component
export default class Button extends Vue {
  /** Mark the button as important */
  @Prop({ type: Boolean }) prominent!: boolean;
  /** Show a loading indicator */
  @Prop({ type: Boolean }) loading!: boolean;
  /** Disable interaction with the button */
  @Prop({ type: Boolean }) disabled!: boolean;
  /** Size of the button */
  @Prop({
    required: false,
    validator(value) {
      return ["small", "normal", "medium", "large"].includes(value);
    }
  })
  size?: string;

  get classNames() {
    let array = ["button"];
    if (this.prominent) {
      array.push("is-link");
    }
    if (this.loading) {
      array.push("is-loading");
    }
    if (this.size) {
      array.push("is-" + this.size);
    }
    return array;
  }
}
